import React from 'react';
import DocumentViewer from '../components/documentsComp/DocumentViewer';

interface ViewDocumentsProps {
  fetchDocument: (kboNumber: string, documentId: string) => Promise<string>;
  backLink: string;
  title: string;
}

const ViewDocuments: React.FC<ViewDocumentsProps> = ({ fetchDocument, backLink, title }) => {
  return <DocumentViewer fetchDocument={fetchDocument} backLink={backLink} title={title} />;
};

export default ViewDocuments;
